module.exports = __webpack_public_path__ + "static/media/pres_constitution.bb77630e.jpg";